import { gql } from '@apollo/client';
import React, { useMemo } from 'react';
import { SwiperOptions } from 'swiper';
import { getActiveVariantBy } from '../../lib/getActiveVariantBy';
import { ResponsiveImage } from '../ResponsiveImage';
import { compact } from '../../lib/compact';
import { MobileProductMediaGalleryFragment } from '../../generated/types/MobileProductMediaGalleryFragment';
import { SwiperCarousel } from '../SwiperCarousel';
import './MobileProductMediaGallery.scss';

export const MOBILE_PRODUCT_MEDIA_GALLERY_VARIANT_FRAGMENT = gql`
  fragment MobileProductMediaGalleryVariantFragment on VariantData {
    id
    primaryImage: primary_image_urls {
      large
    }
    alternateImages: alternate_image_urls {
      large
    }
  }
`;

export const MOBILE_PRODUCT_MEDIA_GALLERY_FRAGMENT = gql`
  fragment MobileProductMediaGalleryFragment on Variant {
    id
    name
    masterVariant: master_variants_data {
      ...MobileProductMediaGalleryVariantFragment
    }
    otherVariants: other_variants_data {
      ...MobileProductMediaGalleryVariantFragment
    }
  }
  ${MOBILE_PRODUCT_MEDIA_GALLERY_VARIANT_FRAGMENT}
`;

export interface Props {
  variant: MobileProductMediaGalleryFragment;
}

const SWIPER_MEDIA_GALLERY_CONFIG: SwiperOptions = {
  speed: 500,
  slidesPerView: 1,
  slidesPerGroup: 1,
  loop: true
};

export const MobileProductMediaGallery: React.FC<Props> = ({ variant }) => {
  const activeVariant = useMemo(() => getActiveVariantBy(variant, 'id', variant.id), [variant]);

  const srcs = useMemo(
    () =>
      compact(
        compact([activeVariant.primaryImage, ...activeVariant.alternateImages]).map(
          ({ large }) => large
        )
      ),
    [activeVariant.alternateImages, activeVariant.primaryImage]
  );

  return (
    <div className="MobileProductMediaGallery">
      <SwiperCarousel defaultConfig={SWIPER_MEDIA_GALLERY_CONFIG} key={variant.id}>
        {srcs.map(src => (
          <ResponsiveImage
            key={src}
            className="MobileProductMediaGallery__image"
            src={src}
            alt={variant.name || 'Product view'}
            maxWidth={700}
            maxHeight={1200}
          />
        ))}
      </SwiperCarousel>
    </div>
  );
};
